import { render, staticRenderFns } from "./VerfahrenNeu.vue?vue&type=template&id=9b295b26&"
import script from "./VerfahrenNeu.vue?vue&type=script&lang=js&"
export * from "./VerfahrenNeu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports